import { FC, ReactNode } from "react";

import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { createComponentStyleHook } from "capitalrx-components-2.0/lib/tokens";

import tokenStyles from "./styles.module.css";
import legacyStyles from "./styles.module.scss";
import { NoPaddingFormComponents } from "../Unpadded";

interface GroupLayoutWrapperProps extends NoPaddingFormComponents {
  readonly children: ReactNode,
  readonly orientation: "vertical" | "horizontal";
}

const useResolvedGroupLayoutWrapperStyles = createComponentStyleHook<GroupLayoutWrapperProps>({
  legacyStyles,
  tokenStyles,
  componentTokens: "form_group_layout_wrapper",
});

export const GroupLayoutWrapper: FC<GroupLayoutWrapperProps> = ({ children, orientation, unpadded }) => {
  const { mode, styles, StyleModeBoundary } = useResolvedGroupLayoutWrapperStyles({ children, orientation, unpadded });

  if (orientation === "horizontal") {
    return (
      <StyleModeBoundary mode={mode}>
        <Shelf className={[styles.GroupLayoutWrapper, { unpadded }]}>
          {children}
        </Shelf>
      </StyleModeBoundary>
    );
  }

  return (
    <StyleModeBoundary mode={mode}>
      <Stack spacing={unpadded ? "small" : "none"}>
        {children}
      </Stack>
    </StyleModeBoundary>
  );
};
